/**
 * Created by yibrahim on 20/07/2017.
 */
export class Currency {
  constructor(public id: number = null,
              public code: string = null,
              public name: string = null)
  {}

  static parseCurrenciesResponse(jsonArray: Array<Object>) {
    var objects = jsonArray.map(r => Object.assign(new Currency(), {
      id: r["id"],
      code: r["code"],
      name: r["name"]
    }));

    return objects;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/currency.ts